/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteSocioEcoHistoryActions, {
    deleteSocioEcoHistoryTypes,
} from '../../../redux/collectData/deleteSocioEcoHistory'
import getSocioEcoHistoryActions from '../../../redux/collectData/getSocioEcoHistory'
import { Delete } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* deleteSocioEcoHistorySagas({ response }) {
    try {
        const responseDelete = yield Delete(`csv/economic_data/${response.id}`)
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    getSocioEcoHistoryActions.getSocioEcoHistoryRequest()
                ),
                yield put(
                    deleteSocioEcoHistoryActions.deleteSocioEcoHistorySuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
        } else {
            yield put(
                deleteSocioEcoHistoryActions.deleteSocioEcoHistoryFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(
            deleteSocioEcoHistoryActions.deleteSocioEcoHistoryFailure(error)
        )
    }
}

export function* deleteSocioEcoHistorySaga() {
    yield takeLatest(
        deleteSocioEcoHistoryTypes.DELETE_SOCIO_ECO_HISTORY_REQUEST,
        deleteSocioEcoHistorySagas
    )
}
